import shoeImage from '../../assets/images/shoe.jpeg';
import FORM_FIELDS from '../../templates/form/fields';

export const defaultFormFieldsData = {
  [FORM_FIELDS.PRODUCT_TITLE]: 'Some awesome product by tableskit',
  [FORM_FIELDS.PRODUCT_URL]: 'Product URL',
  [FORM_FIELDS.IMAGE_URL]: window.location.origin + shoeImage,
  [FORM_FIELDS.PRODUCT_SUBTITLE]: 'Top picks for your home',
  [FORM_FIELDS.BUY_BUTTON_TEXT]: 'Check Price on Amazon',
  [FORM_FIELDS.RIBBON_TEXT]: 'Hot Deals',
  [FORM_FIELDS.PRODUCT_DESCRIPTION]: 'product description',
  [FORM_FIELDS.CTA_SUBTITLE]: 'Check Price on Amazon',
  [FORM_FIELDS.PRODUCT_BODY]: `- Ingredient Type: Vegetarian
- Goodness of Black Raisins
- Best Crunch and Taste
- Healthy Cookies`,
};
